module.exports = __webpack_public_path__ + "static/img/sex2.45d2e43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sex2.png
// module id = p3TB
// module chunks = 4